import { numberToPrettyString } from '@cian/utils';
import { NBSP } from '../../constants/symbols';

export function formatMoney(money: number): string {
  return `${numberToPrettyString(money)}${NBSP}₽`;
}
